const green = '#13af72';
const gray = '#f5f5f7';
const white = '#ffffff';
const black = '#000000';
const red = '#E03C45';
const darkGreen = '#0B6944';
const darkGray = '#999999';
const percentGreen = '#0da569';
const inputFocus = '#e4e4e4';
const lightGray = '#cccccc';
const lightBlack = '#212121';
const tableCellGray = '#ededed';

export const COLORS = {
	GREEN: green,
	GRAY: gray,
	WHITE: white,
	BLACK: black,
	LIGHT_BLACK: lightBlack,
	DARK_GREEN: darkGreen,
	DARK_GRAY: darkGray,
	LIGHT_GRAY: lightGray,
	DANGER: red,
	RED: red,
	PERCENT_DAO_GREEN: percentGreen,
	INPUT_FOCUS: inputFocus,
	TABLE_CELL_GRAY: tableCellGray,
};
